import { render } from "./PhoneNumber.vue?vue&type=template&id=1a222db8&ts=true"
import script from "./PhoneNumber.vue?vue&type=script&lang=ts"
export * from "./PhoneNumber.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__